import { Box, Chip, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { memo, useMemo } from 'react'

import { QuestionTag } from '@/types'

interface QuestionCardTagProps {
  title: string
  tags: QuestionTag[]
}

const TAG_COLORS = {
  Competências: 'primary',
  Habilidades: 'secondary',
  Disciplinas: 'success',
  Conteúdos: 'info',
} as const

export const QuestionCardTag = memo<QuestionCardTagProps>(({ title, tags }) => {
  const theme = useTheme()

  const chipColor = useMemo(() => {
    return TAG_COLORS[title as keyof typeof TAG_COLORS] as
      | 'primary'
      | 'secondary'
      | 'success'
      | 'info'
  }, [title])

  if (tags.length === 0) return null

  return (
    <Box data-qa="question-card-tag">
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 600,
          mb: 1.5,
          color: 'text.primary',
        }}>
        {title}
      </Typography>

      <Stack direction="row" flexWrap="wrap" spacing={1}>
        {tags.map(({ id, name }) => (
          <Chip
            key={id}
            label={name}
            variant="outlined"
            color={chipColor}
            size="small"
            sx={{
              borderRadius: 2,
              fontWeight: 500,
              '&:hover': {
                backgroundColor:
                  theme.palette[chipColor]?.main + '08' || theme.palette.action.hover,
              },
            }}
          />
        ))}
      </Stack>
    </Box>
  )
})

QuestionCardTag.displayName = 'QuestionCardTag'
